import { render, staticRenderFns } from "./PortalSeloger.vue?vue&type=template&id=a8ca2586&"
import script from "./PortalSeloger.vue?vue&type=script&lang=js&"
export * from "./PortalSeloger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports